import TaskDetailsPage from './task-details-page'

export default TaskDetailsPage
